var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Listing } from './../../../classes/listing';
import { delay } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { OnInit, ElementRef } from '@angular/core';
import { LOCALLOGIC_SCRIPT } from '../../../classes/dynamicScripts';
import { DomManipulationService } from '../../../services/dom-manipulation/dom-manipulation.service';
import { combineLatest } from 'rxjs';
import { HasSubscriptions } from '../../../components/has-subscriptions';
var PoiWidgetComponent = /** @class */ (function (_super) {
    __extends(PoiWidgetComponent, _super);
    function PoiWidgetComponent(_domManipulationService, _translateService) {
        var _this = _super.call(this) || this;
        _this._domManipulationService = _domManipulationService;
        _this._translateService = _translateService;
        _this.showPOI = false;
        _this.DESKTOP_SIZE = 1366;
        _this.isLeft = true;
        _this.isLoaded = false;
        return _this;
    }
    /**
     * Hide the bar side bar or top bar on local logic map if the switch is off.
     * Toggle back on if the switch is on.
     */
    PoiWidgetComponent.prototype.toggle = function () {
        this.showPOI = !this.showPOI;
        var ele = document.getElementsByClassName('ll-list-container');
        if (!this.showPOI && ele) {
            if (!this.isLeft) {
                this.toggleContainer.nativeElement.style.top = '10px';
            }
            ele[0]['style'].display = 'none';
        }
        else {
            if (!this.isLeft) {
                this.toggleContainer.nativeElement.style.top = '90px';
            }
            ele[0]['style'].display = 'block';
        }
    };
    // Based on the width of the screen we need to position the switch properly
    // When the screen size is less then 1366px then the switch should be under the top bar
    // When the screen size is over 1366px then we want the switch to be to the rightmost of the map
    PoiWidgetComponent.prototype.positionToggle = function () {
        this.isLeft = this.poiWidget.nativeElement.clientWidth >= 750;
    };
    PoiWidgetComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.listing.isOffMarket)
            return; // Do not use this for non-offmarket pages for now
        this.addSub(combineLatest(this._domManipulationService.loadScript(LOCALLOGIC_SCRIPT) // load the script first
        ).pipe(delay(0))
            .subscribe(function () {
            var x = new locallogic.LocalContent('poiWidget', {
                lat: _this.listing.lat,
                lng: _this.listing.lng,
                color: '#004E9B',
                locale: _this._translateService.getBrowserLang(),
                callback: function () { return _this.showPOI = false; },
                basemap: 'google'
            });
            _this.onMapLoad();
        }));
    };
    PoiWidgetComponent.prototype.onMapLoad = function () {
        var _this = this;
        var myTimer = setInterval(function () {
            var widget = document.getElementsByClassName('ll-list-container');
            if (widget && widget.length > 0) {
                _this.positionToggle();
                widget[0]['style'].display = 'none';
                _this.isLoaded = true;
            }
            if (_this.isLoaded) {
                clearInterval(myTimer);
            }
        }, 100);
    };
    PoiWidgetComponent.prototype.onResize = function () {
        if (!this.listing.isOffMarket)
            return;
        this.isLoaded = false;
        // this.positionToggle();
        this.onMapLoad();
    };
    return PoiWidgetComponent;
}(HasSubscriptions));
export { PoiWidgetComponent };
